import { commonValidation } from './validationRule';

export const GlobalValidation = {
  Name: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: true,
    textLimit: 100,
  }),
  Username: commonValidation({
    required: true,
    noBlank: true,
  }).test('valid-username', 'Invalid username', (value) => {
    if (!value) return true;
    const USERNAME_REGEX =
      /^(?=.{4,100}$)(?:[A-Za-z][A-Za-z0-9._\-]*[A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9.%+\-]*[A-Za-z0-9]@(?:[A-Za-z0-9](?:[A-Za-z0-9\-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,})$/;
    return USERNAME_REGEX.test(value);
  }),
  NameWithDoubleSpace: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: false,
    textLimit: 100,
  }),
  Email: commonValidation({ required: true, email: true }),
  Phone: commonValidation({
    required: true,
    numericPhone: true,
    noBlank: true,
  }),
  NonRequiredPhone: commonValidation({
    required: false,
    numericPhone: true,
    noBlank: true,
  }),
  Description: commonValidation({ required: false, textLimit: 1000 }),
  ZipCode: commonValidation({ required: true, digits: true, noBlank: true, min: 5, max: 5 }),
  AddressLine1: commonValidation({
    required: true,
    noBlank: true,
    doubleSpace: true,
    alphanumericDot: true,
    textLimit: 500,
  }),
  AddressLine2: commonValidation({
    required: false,
    noBlank: true,
    doubleSpace: true,
    alphanumericDot: true,
    textLimit: 500,
  }),
  AddressLineOptional: commonValidation({
    required: false,
    noBlank: false,
    doubleSpace: true,
    alphanumericWithHyphen: true,
    textLimit: 500,
  }),
  DigitWithComma: commonValidation({
    required: true,
    digitsWithComma: true,
    noBlank: true,
  }),
  RequiredNoBlank: commonValidation({ required: true, noBlank: true, doubleSpace: true }),
  RequiredNoBlankAlphanumeric: commonValidation({
    required: true,
    alphanumeric: true,
    noBlank: true,
  }),
  NonRequiredNoBlankAlphanumeric: commonValidation({
    required: false,
    alphanumeric: true,
    noBlank: true,
  }),
  NonRequiredNoBlankAlphanumericWithSmallBrackets: commonValidation({
    required: false,
    noBlank: true,
    allowSmallBrackets: true,
  }),
  RequiredNoBlankAlphanumericWithSmallBrackets: commonValidation({
    required: true,
    noBlank: true,
    allowSmallBrackets: true,
  }),
  Date: commonValidation({
    required: true,
    isDate: true,
  }),
};
